<template>
    <v-container>
        <h1 class="page-heading">Community Battery</h1>
    </v-container>
    <v-container v-if="!userHasAccess">
        <RequestAccess
            desc_text="Would you like to connect to a community battery in your area?"
            button_text="Yes, install community batteries"
            alt_text="Connect to an existing battery"
            :feature_name="featureName"
        />
    </v-container>
    <v-container v-else>
        <v-row no-gutters class="mb-6">
            <v-col>
                <p class="title font-medium">32</p>
                <p class="font-thin">Total Connections</p>
            </v-col>
            <v-col>
                <p class="title font-medium">326</p>
                <p class="font-thin">Days Until Maintenance</p>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="my-5 pa-4 rounded-xl" elevation="4">
                    <v-card-title class="font-medium subtitle"
                        >Personal</v-card-title
                    >

                    <v-container fluid>
                        <v-row class="d-flex justify-space-between">
                            <p class="text-sm ml-3">3kWh of 10 kWh Used</p>
                            <p class="text-sm mr-3 text-clickable">
                                Need more capacity?
                                <v-dialog
                                    v-model="dialog"
                                    activator="parent"
                                    max-width="600px"
                                >
                                    <v-card>
                                        <v-card-text class="text-center">
                                            Your request to increase your
                                            personal capacity has been
                                            <strong>submitted for review</strong
                                            >. Our support team will get back to
                                            you soon.
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-btn
                                                color="#ffb700"
                                                block
                                                @click="dialog = false"
                                                >I Understand</v-btn
                                            >
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </p>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-progress-linear
                                    v-model="personalstorage"
                                    rounded
                                    height="25"
                                    color="#ffd876"
                                >
                                    <strong
                                        >{{
                                            Math.ceil(personalstorage)
                                        }}%</strong
                                    >
                                </v-progress-linear>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-chip class="mt-2" color="#ffc941">
                                    Used
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-divider></v-divider>
                    <v-container fluid>
                        <v-row>
                            <v-col>
                                <v-card
                                    elevation="3"
                                    max-width="344"
                                    class="rounded-lg pa-2 bg-yellow-cust"
                                    ><v-card-title class="font-thin text"
                                        >Monthly Average</v-card-title
                                    >
                                    <v-card-title class="font-thick title"
                                        >9.29
                                        <span class="font-gray"
                                            >kWh</span
                                        ></v-card-title
                                    >
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card
                                    elevation="3"
                                    max-width="344"
                                    class="rounded-lg pa-2 bg-yellow-cust"
                                    ><v-card-title class="font-thin text"
                                        >Lifetime Consumption</v-card-title
                                    >
                                    <v-card-title class="font-thick title"
                                        >9.29
                                        <span class="font-gray"
                                            >kWh</span
                                        ></v-card-title
                                    >
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card class="my-5 pa-4 rounded-xl" elevation="4">
                    <v-card-title class="font-medium subtitle"
                        >Community</v-card-title
                    >

                    <v-container fluid>
                        <v-row class="d-flex justify-space-between">
                            <p class="text-sm ml-3">450kWh of 1000 kWh Used</p>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-progress-linear
                                    v-model="communitystorage"
                                    rounded
                                    height="25"
                                    color="#ffd876"
                                >
                                    <strong
                                        >{{
                                            Math.ceil(communitystorage)
                                        }}%</strong
                                    >
                                </v-progress-linear>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-chip class="mt-2" color="#ffc941">
                                    Used
                                </v-chip>
                            </v-col>
                        </v-row>
                    </v-container>
                    <v-divider></v-divider>
                    <v-container fluid>
                        <v-row>
                            <v-col>
                                <v-card
                                    elevation="3"
                                    max-width="344"
                                    class="rounded-lg pa-2 bg-yellow-cust"
                                    ><v-card-title class="font-thin text"
                                        >Monthly Average</v-card-title
                                    >
                                    <v-card-title class="font-thick title"
                                        >450
                                        <span class="font-gray"
                                            >kWh</span
                                        ></v-card-title
                                    >
                                </v-card>
                            </v-col>
                            <v-col>
                                <v-card
                                    elevation="3"
                                    max-width="344"
                                    class="rounded-lg pa-2 bg-yellow-cust"
                                    ><v-card-title class="font-thin text"
                                        >Lifetime Consumption</v-card-title
                                    >
                                    <v-card-title class="font-thick title"
                                        >450
                                        <span class="font-gray"
                                            >kWh</span
                                        ></v-card-title
                                    >
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import RequestAccess from "@/components/RequestAccess.vue";
import { computed } from "@vue/runtime-core";
import store from "@/store";
export default {
    name: "CommunityBatteryView",
    components: { RequestAccess },
    data: () => ({ personalstorage: 30, communitystorage: 55, dialog: false }),
    setup() {
        const featureName = "Community Battery";
        const userHasAccess = computed(
            () => store.state.user?.features?.includes(featureName) || false
        );
        return {
            featureName,
            userHasAccess,
        };
    },
};
</script>

<style lang="scss" scoped>
h1 {
    font-size: 50px;
}
.text-clickable {
    color: #ffb700;
    font-size: 14px;
    cursor: pointer;
}
</style>
